import { render, staticRenderFns } from "./Rent.vue?vue&type=template&id=ddb70228&scoped=true&"
import script from "./Rent.vue?vue&type=script&lang=js&"
export * from "./Rent.vue?vue&type=script&lang=js&"
import style0 from "./Rent.vue?vue&type=style&index=0&id=ddb70228&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb70228",
  null
  
)

export default component.exports